module.exports = __webpack_public_path__ + "img/hrm-raymond-sm.0d06e0a.png";